import { Link } from 'react-router-dom';
import { usePageMeta, Reveal } from '../lib/site';
import { CardHeader, CtaBand } from '../components/Bits';

const BENEFITS = [
  ['White-glove onboarding', 'We set up your tee sheet, rates, and staff with you. The heavy lifting is ours.'],
  ['A direct line', 'The people on your calls are the people who ship the software. No queue, no ticket number.'],
  ['Shape the product', 'Founding-course feedback steers what gets built. Ask for something Tuesday, see it Friday.'],
  ['First in line', 'Early access to new features, and the player network grows around your course first.'],
  ['The founder lock', 'The $400 is the whole software bill, forever. Courses that come after the window pay the standing plans.'],
];

export default function Founding() {
  usePageMeta(
    'Founding Course Program | MyGolfLinks',
    'Founding courses pay $400 once, not a monthly bill, and lock in the platform forever. A small group of Indiana courses, building LinksOS with us.'
  );

  return (
    <main>
      <section style={{ padding: 'clamp(140px, 16vw, 180px) 0 clamp(48px, 6vw, 72px)' }}>
        <div className="wrap">
          <Reveal>
            <p className="mono" style={{ fontSize: 12.5, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--fairway)', fontWeight: 500, marginBottom: 20 }}>
              Founding Course Program
            </p>
            <h1 className="display" style={{ maxWidth: 780 }}>Be one of the founding courses.</h1>
            <p className="lede" style={{ margin: '24px 0 32px' }}>
              We are launching with a small group of Indiana courses and building LinksOS around
              how they actually run. The deal for getting in early is deliberately simple.
            </p>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <Link to="/demo" className="btn btn-gold">Book a demo</Link>
              <Link to="/courses" className="btn btn-line">See what LinksOS does</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band-pine on-pine">
        <div className="wrap" style={{ padding: 'clamp(64px, 8vw, 100px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal className="g2" style={{ alignItems: 'center' }}>
            <div>
              <div className="mono" style={{ fontSize: 'clamp(3.4rem, 8vw, 5.4rem)', fontWeight: 600, lineHeight: 1, color: 'var(--gold-bright)' }}>
                $400
              </div>
              <div className="mono" style={{ fontSize: '1rem', letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--cream-mut)', marginTop: 10 }}>
                once
              </div>
            </div>
            <div>
              <h2 className="h2" style={{ marginBottom: 16 }}>One payment. That's the bill.</h2>
              <p className="lede">
                Not per month, not per year. Founding courses pay $400 one time and get the full
                platform, forever. When the founding window closes, new courses pay the standing
                plans. The published transaction fees stay the same for everyone; that part is what
                keeps us honest.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ padding: 'clamp(64px, 8vw, 100px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal>
            <CardHeader no="01" label="What founding courses get" />
            <h2 className="h2" style={{ maxWidth: 640 }}>More than a software vendor</h2>
          </Reveal>
          <Reveal className="ledger" style={{ marginTop: 38 }}>
            {BENEFITS.map(([t, b], i) => (
              <div className="led" key={t}>
                <span className="led-no">{i + 1}</span>
                <span className="led-title">{t}</span>
                <span className="led-body">{b}</span>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="The best seats go to the first courses"
        sub="Thirty minutes on video. We walk the demand side, the tee sheet, and exactly what your $400 covers. If it isn't a fit, we'll say so."
      />
    </main>
  );
}
